import { LineProgressBar } from 'mobily-ui-library/lib';

import CircleCancel from '../../assets/CircleCancel.svg';
import CircleBackArrow from '../../assets/CircleBackArrow.svg';

import './HeaderNavigation.scss';

interface Props {
    rtl: boolean;
    showBackArrow: boolean;
    handleBackArrow?: () => void;
    handleHeaderCancel: () => void;
    percent: number;
}

function HeaderNavigation({ rtl, showBackArrow = false, handleBackArrow, handleHeaderCancel, percent }: Props) {
    return (
        <div className='deviceSubsidy__headerNav'>
            <img
                src={CircleBackArrow}
                alt='back-arrow'
                className='DSHN__backArrow'
                onClick={handleBackArrow}
                style={{ visibility: showBackArrow ? "visible" : "hidden" }}
            />
            <LineProgressBar rtl={rtl} percent={percent} />
            <img src={CircleCancel} alt='cancel' className='DSHN__Cancel' onClick={handleHeaderCancel} />
        </div>
    )
}

export default HeaderNavigation